import React, { useState } from 'react';

import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import { Menu, MenuItem, FormControlLabel, Checkbox, Box, Typography, Button, Stack } from '@mui/material';
import { Button as ActionButton } from 'react-admin';

export interface ColumnOption {
  key: string;
  label: string;
  visible: boolean;
  name?: string;
}

interface MSelectColumnsButtonProps {
  options: ColumnOption[];
  onChange: (updatedColumns: ColumnOption[]) => void;
}

// TODO: move to libs
export const MSelectColumnsButton: React.FC<MSelectColumnsButtonProps> = ({ options, onChange }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [tempOptions, setTempOptions] = useState<ColumnOption[]>(options);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setTempOptions(options);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColumnToggle = (columnKey: string) => {
    const updated = tempOptions.map(col => (col.key === columnKey ? { ...col, visible: !col.visible } : col));
    setTempOptions(updated);
  };

  const handleSave = () => {
    onChange(tempOptions);
    handleClose();
  };

  const visibleCount = tempOptions.filter(c => c.visible).length;

  return (
    <>
      <ActionButton label='Columns' onClick={handleClick} startIcon={<ViewWeekIcon />} />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}>
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant='subtitle2' sx={{ fontWeight: 'bold' }}>
            Visible Columns ({visibleCount})
          </Typography>
        </Box>

        <Box sx={{ maxHeight: 300, overflowY: 'auto' }}>
          {tempOptions.map(column => (
            <MenuItem key={column.key} onClick={() => handleColumnToggle(column.key)} sx={{ pl: 0, pr: 2 }}>
              <FormControlLabel
                control={<Checkbox checked={column.visible} onChange={() => {}} size='small' />}
                label={column.label}
                sx={{ m: 0, flex: 1 }}
              />
            </MenuItem>
          ))}
        </Box>

        <Box sx={{ px: 2, py: 1 }}>
          <Stack direction='row' spacing={1} justifyContent='flex-end'>
            <Button size='small' onClick={handleClose}>
              Cancel
            </Button>
            <Button size='small' variant='contained' color='primary' onClick={handleSave}>
              Save
            </Button>
          </Stack>
        </Box>
      </Menu>
    </>
  );
};
